import Mobile from '../assets/Techdata1.jpg'
import Laptop from '../assets/Techdata2.jpg'
import Audio from '../assets/Techdata3.jpg'
import Power from '../assets/Techdata4.jpg'
import Cases from '../assets/Techdata5.jpg'
import Accessories from '../assets/Techdata6.jpg'
import Flagship from '../assets/Techdata7.jpg'
import Ultrabook from '../assets/Techdata8.jpg'
import Ultrabook1 from '../assets/Techdata9.jpg'
import Ultrabook2 from '../assets/Techdata10.jpg'
import GamingHeadset from '../assets/Techdata11.jpg'
import Airdrops from '../assets/Techdata12.jpg'
import Charger from '../assets/Techdata13.jpg'
import Phone from '../assets/Techdata14.jpg'
import Wireless from '../assets/Techdata15.jpg'
import Cable from '../assets/Techdata16.jpg'
import HeroMobile from '../assets/Herofocus1.jpg'
import HeroLaptop from '../assets/Herofocus2.jpg'
import HeroAccessories from '../assets/Herofocus3.jpg'
import Lifestyle1 from '../assets/Herofocus4.jpg'
import Lifestyle from '../assets/Herofocus5.jpg'
import Acceso1 from '../assets/Herofocus6.jpg'
import Acceso2 from '../assets/Herofocus7.jpg'
import Acceso3 from '../assets/Herofocus8.jpg'
import Market1 from '../assets/Herofocus9.jpg'
import Market2 from '../assets/Herofocus10.jpg'
import Market3 from '../assets/Herofocus11.jpg'
import Market4 from '../assets/Herofocus12.jpg'
import exterior from '../assets/Herofocus13.jpg'
import interior from '../assets/Herofocus14.jpg'
import ctaimage from '../assets/Herofocus15.jpg'

export interface Category {
  id: string;
  label: string;
  blurb: string;
  image: string;
  tag: string;
}

export interface TechProduct {
  id: string;
  name: string;
  category: string;
  price: string;
  availability: string;
  description: string;
  images: string[];
  featured?: boolean;
  tag?: string;
}

export const categories: Category[] = [
  {
    id: "mobile",
    label: "Mobile",
    blurb: "Smartphones and mobile devices",
    tag: "Phones",
    image: Mobile
  },
  {
    id: "laptop",
    label: "Laptop",
    blurb: "Computing and laptop products",
    tag: "Computing",
    image: Laptop
  },
  {
    id: "audio",
    label: "Audio",
    blurb: "Headsets, earphones and Bluetooth speakers",
    tag: "Sound",
    image: Audio
  },
  {
    id: "power",
    label: "Power",
    blurb: "Chargers, cables and charging accessories",
    tag: "Charging",
    image: Power
  },
  {
    id: "cases",
    label: "Cases",
    blurb: "Mobile cases and protection",
    tag: "Protection",
    image: Cases
  },
  {
    id: "accessories",
    label: "Accessories",
    blurb: "Other everyday technology essentials",
    tag: "Everyday",
    image: Accessories
  },
];

export const products: TechProduct[] = [
  {
    id: "flagship-phone",
    name: "Flagship Smartphone",
    category: "mobile",
    price: "£649",
    availability: "Available in store",
    tag: "Featured",
    featured: true,
    description:
      "A flagship smartphone with a vivid display, pro-grade camera system and all-day battery — perfect for everyday use and available at Fist Limited in Liverpool.",
    images: [Flagship, Ultrabook],
  },
  {
    id: "ultrabook-laptop",
    name: "Slim Ultrabook Laptop",
    category: "laptop",
    price: "£899",
    availability: "Available in store",
    featured: true,
    description:
      "A lightweight aluminium ultrabook built for work and study — long battery life, crisp display and effortless everyday performance from Fist Limited.",
    images: [Ultrabook1, Ultrabook2],
  },
  {
    id: "wireless-headset",
    name: "Wireless Over-Ear Headset",
    category: "audio",
    price: "£149",
    availability: "Available in store",
    description:
      "Immersive over-ear wireless headset with plush cushions, rich bass and long playtime — everyday sound from Fist Limited.",
    images: [GamingHeadset
    ],
  },
  {
    id: "bt-speaker",
    name: "Bluetooth Speaker",
    category: "audio",
    price: "£79",
    availability: "Available in store",
    description:
      "A compact Bluetooth speaker with room-filling sound and a robust finish — great for the home or on the go, from Fist Limited.",
    images: [Airdrops
    ],
  },
  {
    id: "gan-charger",
    name: "GaN Fast Charger",
    category: "power",
    price: "£29",
    availability: "Available in store",
    description:
      "A compact GaN fast charger that powers your phone and laptop quickly — smart, portable charging from Fist Limited.",
    images: [Charger
    ],
  },
  {
    id: "phone-case",
    name: "Premium Phone Case",
    category: "cases",
    price: "£15",
    availability: "Available in store",
    description:
      "A slim, protective case in a premium finish that keeps your phone safe in style — available at Fist Limited in Liverpool.",
    images: [Phone
    ],
  },
  {
    id: "true-wireless-earbuds",
    name: "True Wireless Earphones",
    category: "audio",
    price: "£59",
    availability: "Available in store",
    tag: "Popular",
    description:
      "Compact true wireless earphones with crisp sound and a pocket-sized charging case — everyday listening from Fist Limited.",
    images: [Wireless
    ],
  },
  {
    id: "braided-cable",
    name: "Braided USB-C Cable",
    category: "power",
    price: "£12",
    availability: "Available in store",
    description:
      "A durable braided USB-C cable built to last — dependable charging and data from Fist Limited.",
    images: [Cable
    ],
  },
];

export interface HeroFocus {
  id: string;
  label: string;
  image: string;
}

export const heroFocusImages: Record<string, string> = {
  mobile: HeroMobile,
  laptop: HeroLaptop,
  accessories: HeroAccessories
};

export const lifestyleImages = {
  everyday: Lifestyle1,
  handsPhone: Lifestyle
};

export const accessoriesMacro = {
  cable: Acceso1,
  connector: Acceso2,
  charging: Acceso3
};

export const marketImages = {
  wide: Market1,
  phones: Market2,
  laptop: Market3,
  accessories: Market4,
};

export const storeImages = {
  exterior: exterior,
  interior: interior
};

export const ctaImage = ctaimage;
